"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentType = /** @class */ (function () {
    function ContentType(data) {
        Object.assign(this, data);
    }
    return ContentType;
}());
exports.ContentType = ContentType;
//# sourceMappingURL=content-type.class.js.map